module.exports = __webpack_public_path__ + "img/my.c5a20110.jpg";